export enum StarChefVisitSlots {
    AM_11_00 = '11:00 AM',
    PM_02_00 = '02:00 PM',
    PM_05_00 = '05:00 PM',
}